import {
  CLEAR_COUNTERPARTY_DETAILS,
  CLOSE_ERROR_MODAL_COUNTERPARTY,
  CLOSE_ERROR_POPUP_COUNTERPARTY,
  DELETE_COUNTERPARTY_ERROR,
  DELETE_COUNTERPARTY_REQUEST,
  DELETE_COUNTERPARTY_SUCCESS,
  GET_COUNTERPARTIES_LIST_ERROR,
  GET_COUNTERPARTIES_LIST_REQUEST,
  GET_COUNTERPARTIES_LIST_SUCCESS,
  GET_COUNTERPARTY_DETAILS_ERROR,
  GET_COUNTERPARTY_DETAILS_REQUEST,
  GET_COUNTERPARTY_DETAILS_SUCCESS,
  POST_ADD_COUNTERPARTY_ERROR,
  POST_ADD_COUNTERPARTY_REQUEST,
  POST_ADD_COUNTERPARTY_SUCCESS,
  PUT_UPDATE_COUNTERPARTY_ERROR,
  PUT_UPDATE_COUNTERPARTY_REQUEST,
  PUT_UPDATE_COUNTERPARTY_SUCCESS,
} from './constants';
import { ICounterpartyCreateRequest, ICounterpartyUpdateRequest } from './interfaces';

export const getCounterpartiesListRequest = () => ({
  type: GET_COUNTERPARTIES_LIST_REQUEST,
});
export const getCounterpartiesListSuccess = (data: any) => ({
  type: GET_COUNTERPARTIES_LIST_SUCCESS,
  payload: data,
});
export const getCounterpartiesListError = (error: any) => ({
  type: GET_COUNTERPARTIES_LIST_ERROR,
  payload: error,
});

export const getCounterpartyDetailsRequest = (body: { id: number }) => ({
  type: GET_COUNTERPARTY_DETAILS_REQUEST,
  payload: body,
});
export const getCounterpartyDetailsSuccess = (data: any) => ({
  type: GET_COUNTERPARTY_DETAILS_SUCCESS,
  payload: data,
});
export const getCounterpartyDetailsError = (error: any) => ({
  type: GET_COUNTERPARTY_DETAILS_ERROR,
  payload: error,
});
export const clearCounterpartyDetails = () => ({
  type: CLEAR_COUNTERPARTY_DETAILS,
});

export const postAddCounterpartyRequest = (body: ICounterpartyCreateRequest) => ({
  type: POST_ADD_COUNTERPARTY_REQUEST,
  payload: body,
});
export const postAddCounterpartySuccess = (data: any) => ({
  type: POST_ADD_COUNTERPARTY_SUCCESS,
  payload: data,
});
export const postAddCounterpartyError = (error: any) => ({
  type: POST_ADD_COUNTERPARTY_ERROR,
  payload: error,
});

export const putUpdateCounterpartyRequest = (body: ICounterpartyUpdateRequest) => ({
  type: PUT_UPDATE_COUNTERPARTY_REQUEST,
  payload: body,
});
export const putUpdateCounterpartySuccess = (data: any) => ({
  type: PUT_UPDATE_COUNTERPARTY_SUCCESS,
  payload: data,
});
export const putUpdateCounterpartyError = (error: any) => ({
  type: PUT_UPDATE_COUNTERPARTY_ERROR,
  payload: error,
});

export const deleteCounterpartyRequest = (body: { id: number }) => ({
  type: DELETE_COUNTERPARTY_REQUEST,
  payload: body,
});
export const deleteCounterpartySuccess = (data: any) => ({
  type: DELETE_COUNTERPARTY_SUCCESS,
  payload: data,
});
export const deleteCounterpartyError = (error: any) => ({
  type: DELETE_COUNTERPARTY_ERROR,
  payload: error,
});

export const closeErrorPopUpCounterparty = () => ({
  type: CLOSE_ERROR_POPUP_COUNTERPARTY,
});

export const closeErrorModalCounterparty = () => ({
  type: CLOSE_ERROR_MODAL_COUNTERPARTY,
});

export type Actions =
  | ReturnType<typeof getCounterpartiesListRequest>
  | ReturnType<typeof getCounterpartiesListSuccess>
  | ReturnType<typeof getCounterpartiesListError>
  | ReturnType<typeof getCounterpartyDetailsRequest>
  | ReturnType<typeof getCounterpartyDetailsSuccess>
  | ReturnType<typeof getCounterpartyDetailsError>
  | ReturnType<typeof clearCounterpartyDetails>
  | ReturnType<typeof postAddCounterpartyRequest>
  | ReturnType<typeof postAddCounterpartySuccess>
  | ReturnType<typeof postAddCounterpartyError>
  | ReturnType<typeof putUpdateCounterpartyRequest>
  | ReturnType<typeof putUpdateCounterpartySuccess>
  | ReturnType<typeof putUpdateCounterpartyError>
  | ReturnType<typeof deleteCounterpartyRequest>
  | ReturnType<typeof deleteCounterpartySuccess>
  | ReturnType<typeof deleteCounterpartyError>
  | ReturnType<typeof closeErrorPopUpCounterparty>
  | ReturnType<typeof closeErrorModalCounterparty>;
